const styles = () => ({
  root: {
    width: '100%',
    maxWidth: 1024,
    marginTop: 24,
    padding: '24px 32px',
    borderRadius: 16,
    backgroundColor: '#015FFB',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 20,
    boxShadow: '0 12px 24px -4px rgba(145, 158, 171, 0.12)',
    '@media (max-width: 600px)': {
      flexDirection: 'column',
      alignItems: 'flex-start',
      padding: 24,
    },
  },
  heading: {
    color: '#fff',
    fontFamily: 'Inter',
    fontSize: '20px',
    fontWeight: 800,
    lineHeight: '28px',
  },
  body: {
    marginTop: 4,
    color: 'rgba(255, 255, 255, 0.85)',
    fontFamily: 'Inter',
    fontSize: '15px',
    lineHeight: '150%',
  },
  button: {
    flexShrink: 0,
    // Shape, padding and weight come from CoreButton, like the other pricing
    // buttons. `&&` outranks its contained-button colours, which would
    // otherwise paint this button the same blue as the strip. White with brand
    // text, pale blue on hover, like the website.
    '&&': {
      backgroundColor: '#fff',
      color: '#015FFB',
      boxShadow: 'none',
    },
    '&&:hover': {
      backgroundColor: '#E3F3FF',
      color: '#015FFB',
      boxShadow: 'none',
    },
  },
})

export default styles
